/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { CouponSearchResponseDto } from '../../models/coupon-search-response-dto';

export interface TeacherCouponControllerSearch$Params {

/**
 * 페이지 크기
 */
  pageSize: number;

/**
 * 정렬 기준
 */
  orderBy?: string;

/**
 * 정렬 방향
 */
  align?: 'asc' | 'desc';

/**
 * 검색어
 */
  query?: string;

/**
 * 페이지 번호
 */
  pageNo: number;

/**
 * 상품 ID
 */
  productIds?: Array<string>;

/**
 * 관리자 세그먼트
 */
  adminSegment?: string;

/**
 * 회원 ID
 */
  parentId?: string;

/**
 * 발행 대상
 */
  targetType?: 'CENTER' | 'TEACHER' | 'PARENT';

/**
 * 발행 대상
 */
  segment2?: 'ALL' | 'PERSONAL' | 'CENTER';

/**
 * 관리자 전용 즐겨찾기 여부
 */
  isFavoriteForAdmin?: boolean;

/**
 * 자동 발급 쿠폰 ID
 */
  autoIssuedCouponId?: string;

/**
 * 회원 ID
 */
  userId?: string;

/**
 * 역할
 */
  memberRole?: 'PARENT' | 'TEACHER';

/**
 * 상태
 */
  status?: 'WAITING' | 'ACTIVE' | 'STOPPED' | 'EXPIRED' | 'COMPLETED' | 'CANCELED';

/**
 * 회원 조회 여부 (회원 조회 시 만료, 중지된 쿠폰은 보여지지 않습니다.)
 */
  searchByUser?: boolean;

/**
 * 사용자 세그먼트
 */
  segment?: 'AVAILABLE' | 'USED';

/**
 * 발행 대상 센터 ID
 */
  centerId?: string;

/**
 * 자동 발급된 쿠폰 보지 않기 여부
 */
  noAuto?: boolean;

/**
 * 쿠폰 그룹 검색 여부
 */
  isLeaf?: boolean;

/**
 * 카테고리 레벨
 */
  categoryLevel?: number;

/**
 * 대분류 카테고리 리스트
 */
  bigCategories?: Array<string>;

/**
 * 중분류 카테고리 리스트
 */
  mediumCategories?: Array<string>;
}

export function teacherCouponControllerSearch(http: HttpClient, rootUrl: string, params: TeacherCouponControllerSearch$Params, context?: HttpContext): Observable<StrictHttpResponse<CouponSearchResponseDto>> {
  const rb = new RequestBuilder(rootUrl, teacherCouponControllerSearch.PATH, 'get');
  if (params) {
    rb.query('pageSize', params.pageSize, {});
    rb.query('orderBy', params.orderBy, {});
    rb.query('align', params.align, {});
    rb.query('query', params.query, {});
    rb.query('pageNo', params.pageNo, {});
    rb.query('productIds', params.productIds, {});
    rb.query('adminSegment', params.adminSegment, {});
    rb.query('parentId', params.parentId, {});
    rb.query('targetType', params.targetType, {});
    rb.query('segment2', params.segment2, {});
    rb.query('isFavoriteForAdmin', params.isFavoriteForAdmin, {});
    rb.query('autoIssuedCouponId', params.autoIssuedCouponId, {});
    rb.query('userId', params.userId, {});
    rb.query('memberRole', params.memberRole, {});
    rb.query('status', params.status, {});
    rb.query('searchByUser', params.searchByUser, {});
    rb.query('segment', params.segment, {});
    rb.query('centerId', params.centerId, {});
    rb.query('noAuto', params.noAuto, {});
    rb.query('isLeaf', params.isLeaf, {});
    rb.query('categoryLevel', params.categoryLevel, {});
    rb.query('bigCategories', params.bigCategories, {});
    rb.query('mediumCategories', params.mediumCategories, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<CouponSearchResponseDto>;
    })
  );
}

teacherCouponControllerSearch.PATH = '/api/teacher-coupon';
